<template>
    <div class="bg-gray-200 | animate-pulse" :class="round ? 'rounded-full' : 'rounded-lg'" />
</template>

<script>
    export default {
        props: {
            round: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
